(function () {
  var KEY = 'fabcycleWishlistV1';

  function cleanText(value) {
    if (value === null || value === undefined) return '';
    var div = document.createElement('div');
    div.innerHTML = String(value);
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function readWishlist() {
    try {
      var value = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('fabcycle:wishlist-changed', {
        detail: { items: items }
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function parseProduct(control) {
    if (control._fabcycleWishlistProduct) {
      return control._fabcycleWishlistProduct;
    }

    var data = control.querySelector('[data-fabcycle-wishlist-product]');
    if (!data) return null;

    try {
      control._fabcycleWishlistProduct = JSON.parse(data.textContent);
      return control._fabcycleWishlistProduct;
    } catch (error) {
      return null;
    }
  }

  function contains(items, id) {
    return items.some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function updateControl(control) {
    var product = parseProduct(control);
    var button = control.querySelector('[data-fabcycle-wishlist-toggle]');
    var label = control.querySelector('[data-fabcycle-wishlist-label]');

    if (!product || !button) return;

    var saved = contains(readWishlist(), product.id);

    button.classList.toggle('is-active', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');

    button.setAttribute(
      'aria-label',
      (saved ? 'Remove ' : 'Add ') +
        product.title +
        (saved ? ' from wishlist' : ' to wishlist')
    );

    if (label) {
      label.textContent = saved ? 'Saved to wishlist' : 'Add to wishlist';
    }
  }

  function toggleProduct(control) {
    var product = parseProduct(control);
    if (!product) return;

    product.price = cleanText(product.price);

    var items = readWishlist();

    var index = items.findIndex(function (item) {
      return String(item.id) === String(product.id);
    });

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift(product);
    }

    if (writeWishlist(items)) {
      updateControl(control);
    }
  }

  function initControls() {
    document
      .querySelectorAll('[data-fabcycle-wishlist-control]')
      .forEach(function (control) {
        var button = control.querySelector(
          '[data-fabcycle-wishlist-toggle]'
        );

        if (!button || button.dataset.fabcycleWishlistReady === 'true') {
          return;
        }

        button.dataset.fabcycleWishlistReady = 'true';

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          toggleProduct(control);
        });

        updateControl(control);
      });
  }

  function makeHeartButton() {
    var button = document.createElement('button');

    button.type = 'button';
    button.className = 'fabcycle-wishlist-grid-button';
    button.setAttribute('data-fabcycle-wishlist-toggle', '');
    button.setAttribute('aria-pressed', 'false');

    button.innerHTML =
      '<svg class="fabcycle-wishlist-heart" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21.3l7.8-7.8 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/>' +
      '</svg>' +
      '<span class="visually-hidden">Add to wishlist</span>';

    return button;
  }

  function injectGridControls() {
    document
      .querySelectorAll('.grid-product[data-product-id]')
      .forEach(function (grid) {
        var content = grid.querySelector('.grid-product__content');

        if (
          !content ||
          content.querySelector('.fabcycle-wishlist-control--grid')
        ) {
          return;
        }

        var link = grid.querySelector('.grid-product__link');
        var titleNode = grid.querySelector('.grid-product__title');

        if (!link || !titleNode) return;

        var image = grid.querySelector(
          '.grid-product__image-mask img'
        );

        var priceNode =
          grid.querySelector('.grid-product__price .sale-price') ||
          grid.querySelector('.grid-product__price');

        var control = document.createElement('div');

        control.className =
          'fabcycle-wishlist-control fabcycle-wishlist-control--grid';

        control.setAttribute(
          'data-fabcycle-wishlist-control',
          ''
        );

        control._fabcycleWishlistProduct = {
          id: grid.getAttribute('data-product-id'),
          handle:
            grid.getAttribute('data-product-handle') || '',
          title: cleanText(titleNode.textContent),
          url: link.getAttribute('href') || '',
          image: image
            ? image.currentSrc || image.src || ''
            : '',
          price: priceNode
            ? cleanText(priceNode.textContent)
            : ''
        };

        control.appendChild(makeHeartButton());
        content.appendChild(control);
      });
  }

  function productHandle(item) {
    if (item.handle) {
      return String(item.handle);
    }

    var match = String(item.url || '').match(
      /\/products\/([^/?#]+)/
    );

    return match ? match[1] : '';
  }

  function rootPath() {
    return (
      (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '/'
    );
  }

  function addWishlistItemToCart(item, button) {
    var handle = productHandle(item);

    if (!handle || button.disabled) return;

    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(
      rootPath() +
        'products/' +
        encodeURIComponent(handle) +
        '.js',
      {
        credentials: 'same-origin'
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product unavailable');
        }

        return response.json();
      })
      .then(function (product) {
        var variants = Array.isArray(product.variants)
          ? product.variants
          : [];

        var variant = variants.find(function (candidate) {
          return candidate.available;
        });

        if (!variant) {
          throw new Error('Sold out');
        }

        return fetch(rootPath() + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1
              }
            ]
          })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Could not add to cart');
        }

        return response.json();
      })
      .then(function () {
        button.disabled = true;
        button.textContent = 'Added';
      })
      .catch(function (error) {
        button.disabled = false;

        button.textContent =
          error && error.message === 'Sold out'
            ? 'Sold out'
            : originalText;
      });
  }

  function syncWishlistCartState() {
    var wishlistPage = document.querySelector(
      '[data-fabcycle-wishlist-page]'
    );

    if (!wishlistPage) return;

    fetch(rootPath() + 'cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Could not read cart');
        }

        return response.json();
      })
      .then(function (cart) {
        var handles = {};

        (cart.items || []).forEach(function (item) {
          var handle =
            item.handle ||
            item.product_handle ||
            '';

          if (!handle && item.url) {
            var match = String(item.url).match(
              /\/products\/([^/?#]+)/
            );

            handle = match ? match[1] : '';
          }

          if (handle) {
            handles[String(handle)] = true;
          }
        });

        document
          .querySelectorAll(
            '[data-fabcycle-wishlist-add]'
          )
          .forEach(function (button) {
            var handle =
              button.getAttribute(
                'data-product-handle'
              ) || '';

            var inCart = !!handles[handle];

            button.disabled = inCart;
            button.textContent = inCart
              ? 'Added'
              : 'Add to cart';
          });
      })
      .catch(function () {
        // If the cart check fails, leave the buttons usable.
      });
  }

  function buildCard(item) {
    var wrapper = document.createElement('div');

    wrapper.className =
      'grid__item small--one-half medium-up--one-quarter';

    var card = document.createElement('div');

    card.className = 'fabcycle-wishlist-card';

    if (item.image) {
      var imageLink = document.createElement('a');

      imageLink.href = item.url;
      imageLink.className =
        'fabcycle-wishlist-card__image';

      var image = document.createElement('img');

      image.src = item.image;
      image.alt = item.title || '';
      image.loading = 'lazy';

      imageLink.appendChild(image);
      card.appendChild(imageLink);
    }

    var title = document.createElement('a');

    title.href = item.url;
    title.className =
      'fabcycle-wishlist-card__title';

    title.textContent =
      item.title || 'Product';

    card.appendChild(title);

    if (item.price) {
      var price = document.createElement('div');

      price.className =
        'fabcycle-wishlist-card__price';

      price.textContent = cleanText(item.price);

      card.appendChild(price);
    }

    var actions = document.createElement('div');

    actions.className =
      'fabcycle-wishlist-card__actions';

    var add = document.createElement('button');

    add.type = 'button';
    add.className = 'btn btn--small';
    add.textContent = 'Add to cart';

    add.setAttribute(
      'data-fabcycle-wishlist-add',
      ''
    );

    add.setAttribute(
      'data-product-handle',
      productHandle(item)
    );

    add.addEventListener('click', function () {
      addWishlistItemToCart(item, add);
    });

    actions.appendChild(add);

    var view = document.createElement('a');

    view.href = item.url;
    view.className =
      'btn btn--secondary btn--small';

    view.textContent = 'View product';

    actions.appendChild(view);

    var remove = document.createElement('button');

    remove.type = 'button';
    remove.className =
      'fabcycle-wishlist-remove';

    remove.textContent = 'Remove';

    remove.addEventListener('click', function () {
      var items = readWishlist().filter(
        function (saved) {
          return (
            String(saved.id) !==
            String(item.id)
          );
        }
      );

      writeWishlist(items);
    });

    actions.appendChild(remove);

    card.appendChild(actions);
    wrapper.appendChild(card);

    return wrapper;
  }

  function renderWishlistPage() {
    var root = document.querySelector(
      '[data-fabcycle-wishlist-page]'
    );

    if (!root) return;

    root.innerHTML = '';

    var items = readWishlist();

    if (!items.length) {
      var empty = document.createElement('div');

      empty.className =
        'fabcycle-wishlist-empty rte';

      empty.innerHTML =
        '<p>Your wishlist is empty.</p>' +
        '<p><a class="btn" href="/collections/new-arrivals">' +
        'Shop new arrivals' +
        '</a></p>';

      root.appendChild(empty);

      return;
    }

    var grid = document.createElement('div');

    grid.className =
      'grid grid--uniform fabcycle-wishlist-grid';

    items.forEach(function (item) {
      grid.appendChild(buildCard(item));
    });

    root.appendChild(grid);

    syncWishlistCartState();
  }

  function refresh() {
    injectGridControls();

    initControls();

    document
      .querySelectorAll(
        '[data-fabcycle-wishlist-control]'
      )
      .forEach(updateControl);

    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      refresh
    );
  } else {
    refresh();
  }

  window.addEventListener(
    'fabcycle:wishlist-changed',
    refresh
  );

  window.addEventListener(
    'storage',
    function (event) {
      if (event.key === KEY) {
        refresh();
      }
    }
  );

  document.addEventListener(
    'shopify:section:load',
    refresh
  );

  window.addEventListener(
    'pageshow',
    syncWishlistCartState
  );

  window.addEventListener(
    'focus',
    syncWishlistCartState
  );

  document.addEventListener(
    'visibilitychange',
    function () {
      if (!document.hidden) {
        syncWishlistCartState();
      }
    }
  );
})();